<template>
  <div>
    <nav-breadcrumb :menu="[{label: '录入编辑 授信'}]"/>
    <form-build
      form-name="creditForm"
      :form-data.sync="creditForm"
      :form-columns-group="creditFormColumnsGroup"
      :form-rules="creditFormRules"
      :form-buttons="creditFormButtons"
      label-width="170px"
      ref="FormBuild"
    />
    <el-row>
      <el-col :span="24">
        <files-upload :file-list.sync="fileList"></files-upload>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
          <el-button type="primary" @click="onSubmit('creditForm')">确认提交</el-button>
          <el-button @click="$router.back()">取消</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import FormBuild from '../../../components/FormBuild'
  import Panel from '../../../components/Panel'
  import FilesUpload from '../../../components/FilesUpload'
  import creditTypeOptions from '../../../utils/creditTypeOptions'

  export default {
    name: "CreditEdit",
    data() {
      return {
        creditId: this.$route.query['cr.creditId']||'',
        customerList: [],
        debtorList:{},
        productList: {},
        creditTypeOptions: creditTypeOptions,
        creditForm: {
          "cr__checked": true,
          "cr__creditId": this.$route.query['cr.creditId']||'',
          "cr__creditType": "",
          "cr__creditValidity": [],
          "cr__creditValidity1": "",
          "cr__creditValidity2": "",
          "cr__customerId": "",
          "cr__debtorId": "",
          "cr__financingRatio": "",
          "cr__lineOfCredit": 0,
          "cr__productId": "",
          "cr__threshold": "",
          files: []
        },
        creditFormRules: {
          cr__creditType: [
            {
              required: true,
              message: '授信类型不能为空！'
            }
          ],
          cr__creditValidity: [
            {
              required: true,
              message: '授信起始、截止日期不能为空！'
            }
          ],
          cr__customerId: [
            {
              required: true,
              message: '客户不能为空！'
            }
          ],
          cr__debtorId: [
            {
              required: true,
              message: '供应链不能为空！'
            }
          ],
          cr__financingRatio: [
            {
              required: true,
              message: '融资比例不能为空！'
            }
          ],
          cr__lineOfCredit: [
            {
              required: true,
              message: '授信额度不能为空！'
            }
          ],
          cr__productId: [
            {
              required: true,
              message: '融资产品不能为空！'
            }
          ],
          cr__threshold: [
            {
              required: true,
              message: '融资阈值不能为空！'
            }
          ]
        },
        creditFormButtons: [

        ]
      }
    },
    components: {
      Panel,
      FilesUpload,
      FormBuild
    },
    computed: {
      creditFormColumnsGroup() {
        return [
          {
            label: '授信详情',
            columns: [
              {
                label: '客户名称',
                field: 'cr__customerId',
                component: 'el-select',
                filterable: true,
                options: this.customerList
              },
              {
                label: '供应链',
                field: 'cr__debtorId',
                filterable: true,
                component: 'el-select',
                options: this.debtorList
              },
              {
                label: '融资产品',
                field: 'cr__productId',
                filterable: true,
                component: 'el-select',
                options: this.productList
              },
              {
                label: '授信类型',
                field: 'cr__creditType',
                filterable: true,
                component: 'el-select',
                options: creditTypeOptions
              },
              {
                label: '授信额度',
                field: 'cr__lineOfCredit',
                component: 'el-input',
                unit: '元'
              },
              {
                label: '授信起始截止日期',
                field: 'cr__creditValidity',
                component: 'date-range-picker',
              },
              {
                label: '融资比例',
                field: 'cr__financingRatio',
                component: 'el-input',
                unit: '%'
              },
              {
                label: '融资阀值',
                field: 'cr__threshold',
                component: 'el-input',
                unit: '元'
              },
            ]
          },
        ]
      },
      fileList: {
        get() {
          return this.creditForm.files
        },
        set(newVal) {
          this.creditForm.files = newVal.map(item => Object.assign(item, {
              'ca__fileId': item.fileId,
              'ca__checked': true
            })
          )
        }
      }
    },
    mounted() {
      if( this.creditId ) {
        this.getCustomerCreditDetail(this.creditId)
      }
      this.getCustomerList()
      this.getDebtorList()
      this.getFinanceProductList()
    },
    methods: {
      getCustomerList: function() {
        xhr.getCustomerList({
          pageSize: 1000
        },res=>{
          try{
            if(res.data.status == 'success') {
              this.customerList = res.data.data.map(item=>{
                return {
                  label: item.c__customerName,
                  value: item.c__customerId
                }
              })
            }
          }
          catch (e) {

          }
        })
      },
      getCustomerCreditDetail: function (creditId) {
        xhr.getCustomerCreditDetail({
          'cr.creditId': creditId
        },
        res=> {
          try{
            if(res.data.status == 'success') {
              res.data.data.cr__creditValidity = [
                res.data.data.cr__creditValidity1,
                res.data.data.cr__creditValidity2
              ]
              this.creditForm = res.data.data
            }
          }catch (e) {

          }
        })
      },
      getDebtorList: function () {
        xhr.getDebtorList({
          pageSize: 1000
        },res=>{
          try{
            if(res.data.status == 'success') {
              this.debtorList = res.data.data.map(item=>{
                return {
                  label: item.c__customerName,
                  value: item.c__customerId
                }
              })
            }
          }catch (e) {

          }
        })
      },
      getFinanceProductList: function () {
        xhr.getFinanceProductList(
          {
            pageSize: 1000
          },
          res=>{
            try{
              if(res.data.status == 'success') {
                this.productList = res.data.data.map(item=>{
                  return {
                    label: item.p__productName,
                    value: item.p__productId
                  }
                })
              }
            }catch (e) {

            }
          }
        )
      },
      onSubmit: function (formName) {
        this.$refs.FormBuild.$refs[formName].validate((valid)=>{
          if(valid) {
            [this.creditForm.cr__creditValidity1, this.creditForm.cr__creditValidity2] = this.creditForm.cr__creditValidity

            xhr.updateCustomerCredit(
              this.creditForm,
              res=> {
                try{
                  if(res.data.status == 'success') {

                  }
                  this.$router.push({
                    path: 'List'
                  })
                }catch (e) {

                }
              }
            )
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/CreditEdit.vue